package one.healthium.channels

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlin.time.Clock

class MealPlanChannel {
    private val _mealPlanRefreshFlow = MutableStateFlow(Clock.System.now().toEpochMilliseconds())
    val mealPlanRefreshFlow = _mealPlanRefreshFlow.asStateFlow()

    fun refreshMealPlan() {
        _mealPlanRefreshFlow.value = Clock.System.now().toEpochMilliseconds()
    }
}